(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller(
			'supplierWelcomeEmailEditor',
			supplierWelcomeEmailEditor
		);

	supplierWelcomeEmailEditor.$inject = ['$rootScope', '$scope', '$timeout', '$experiments', 'storeService'];

	function supplierWelcomeEmailEditor($rootScope, $scope, $timeout, $experiments, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		
		// Set navigation properties
		vm.type = 'site';
		$scope.siteId = adminConfig.factory.id;
		$scope.factoryName = adminConfig.factory.name;
	}
})();
